import { Crown, Medal } from "lucide-react";

// Medal palette. Used for the primary podium (large) and per-type mini-podiums.
// Each level has explicit front/top/side colors so the Pillar3D component can
// build a real isometric (perspective) bar instead of a flat gradient.
export const MEDAL_STYLES = {
  1: {
    front: "linear-gradient(180deg, #FFE55C 0%, #FFD700 50%, #FFA500 100%)",
    top: "#FFE98A",
    side: "#B8860B",
    glow: "0 0 24px rgba(255,215,0,0.55), 0 6px 18px rgba(0,0,0,0.25)",
    label: "1°",
    icon: Crown,
    height: "h-44",
    miniHeight: "h-24",
  },
  2: {
    front: "linear-gradient(180deg, #F1F5F9 0%, #C0C0C0 50%, #737373 100%)",
    top: "#E5E7EB",
    side: "#737373",
    glow: "0 0 18px rgba(192,192,192,0.45), 0 4px 14px rgba(0,0,0,0.22)",
    label: "2°",
    icon: Medal,
    height: "h-36",
    miniHeight: "h-20",
  },
  3: {
    front: "linear-gradient(180deg, #E89B5B 0%, #CD7F32 50%, #6B3410 100%)",
    top: "#F2B585",
    side: "#6B3410",
    glow: "0 0 18px rgba(205,127,50,0.45), 0 4px 14px rgba(0,0,0,0.22)",
    label: "3°",
    icon: Medal,
    height: "h-28",
    miniHeight: "h-16",
  },
};

export const EXPECTED_TX_TYPES = ["RF PICK", "RF STAGE", "RF TRNS", "RF RCPT", "RF.RCVR"];
